import React from 'react';

import {HStack, Icon, Text, VStack} from "@chakra-ui/react";
import {FileText} from 'lucide-react';

import {useLanguage} from "@/contexts/languageContext";
import {Skeleton} from "@/components";
import stringUtil from "@/utils/stringUtil";

export const GuideBodySkeleton = ({props}) => {
    return <HStack
        gap="1vw"
        minH="3.5rem"
        overflow="hidden"
        flex={1}
        {...props}
    >
        <VStack align="flex-start" flex={1} overflow="hidden">
            <Skeleton>
                <Text
                    fontWeight="bold"
                    fontSize="md"
                    isTruncated
                >
                    { stringUtil.getRandomString(50, 80) }
                </Text>
            </Skeleton>
        </VStack>
    </HStack>
}

export const GuideBody = ({element, ...props}) => {
    const {language} = useLanguage();

    return (
        <HStack
            gap="1vw"
            minH="3.5rem"
            color={element.deleted ? "gray.400" : "secondary.500"}
            overflow="hidden"
            {...props}
        >
            <Icon as={FileText} boxSize={5}/>
            <VStack align="flex-start" gap={0} flex={1} overflow="hidden">
                <Text
                    fontWeight="bold"
                    fontSize="md"
                    isTruncated
                    color={element.deleted ? "gray.400" : "inherit"}
                >
                    {element?.[`${language}Title`] ?? element?.title?.[language]}
                </Text>
                {
                    element?.typeTitle &&
                    <Text fontSize="sm" opacity={0.7} isTruncated>{element.typeTitle}</Text>
                }
            </VStack>
            {
                element.sortOrder !== null && element.sortOrder !== undefined &&
                <Text fontSize="sm" color="secondary.500">#{element.sortOrder}</Text>
            }
        </HStack>
    );
};

export default GuideBody;
